//좌측 타입별 주문 카운트
import { Fn_activeAxios } from "../function/FnConfig";
import { fn_prevPage, fn_sendOrderList } from "../function/FnBodyOrder";
import { fn_bridge_close, fn_log_error } from "function/FnPosBridge";
import { select_access_token } from "http/TokenConn";
import axios from "axios";

export function api_order_type(rootStore) {
  const searchStore = rootStore.searchStore;
  const api = Fn_activeAxios(rootStore);
  api
    .post(
      "/gate/okgo/search_count",
      JSON.stringify(searchStore.getShopCdSaleDate),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootStore.searchStore.getToken,
        },
      }
    )
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            const orderTypeObj = {
              all: data.progressOrderTotalCnt,
              delivery: data.progressDeliveryCnt,
              pickupAndTable:
                Number(data.progressPickupCnt) + Number(data.progressTableCnt),
            };

            const stepTypeObj = {
              saleSum: data.realTimeSaleSum,
              saleCnt: data.completeCnt,
            };

            const endOrderTypeObj = {
              all: data.processedOrderTotalCnt,
              delivery: data.processedDeliveryCnt,
              pickupAndTable:
                Number(data.processedPickupCnt) +
                Number(data.processedTableCnt),
            };

            searchStore.setOrderTypeObj(orderTypeObj);
            searchStore.setStepTypeObj(stepTypeObj);
            searchStore.setEndOrderTypeObj(endOrderTypeObj);
          }
        }
      }
    })
    .catch((err) => {});
}


// 주문 목록 조회
export function api_order_list(rootStore, type) {
  const searchStore = rootStore.searchStore;
  const orderStore = rootStore.orderStore;
  const settingStore = rootStore.settingStore;

  if (
    rootStore.settingStore.getUserInfo.userId == "" ||
    rootStore.settingStore.getUserInfo.userNm == ""
  ) {
    rootStore.settingStore.setUserInfo(
      "userId",
      localStorage.getItem("userId")
    );
    rootStore.settingStore.setUserInfo(
      "userNm",
      localStorage.getItem("userNm")
    );
  }

  //완료주문 뷰에서 주문거절시 pageCnt
  if (type == "posPush") {
    orderStore.setPagingInfo("max_page", orderStore.getPagingInfo.end_max_page);
    orderStore.setPagingInfo("page_no", orderStore.getPagingInfo.end_max_page);
  }
  let data = JSON.stringify({
    ...searchStore.getShopCdSaleDate,
    orderType: searchStore.getCurrOrderType,
    stepType: searchStore.getCurrStepType,
    viewType: settingStore.getOrderViewType,
    viewOrder: settingStore.getOrderViewOrder,
    pageNo: orderStore.getPagingInfo.page_no,
    searchKey: searchStore.getSearchKey.key,
    searchVal: searchStore.getSearchVal,
    userId: settingStore.getUserInfo.userId,
    userNm: settingStore.getUserInfo.userNm,
    orderEndYn: settingStore.getManagerSetting.orderEnd,
  });
  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/search_main_list", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + rootStore.searchStore.getToken,
      },
    })
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            orderStore.addOrderListAll(
              rootStore.rabbitMqStore.getRabbitAllNew,
              data.list
            );
            orderStore.setPagingInfo("max_page", Number(data.maxPage));
            orderStore.setPagingInfo("end_max_page", Number(data.maxPage));
            rootStore.endOrderStore.setEndOrderCompleteList(data.list);

            //완료취소주문내역 넣기
            if (rootStore.settingStore.getManagerSetting?.orderEnd == "Y") {
              rootStore.endOrderStore.setEndOrderList(data.list);
            }

            if (data.list.length > 0) {
              rootStore.searchStore.setOrderSearchNoDataView(false);
            } else {
              if (rootStore.orderStore.getPagingInfo.page_no > 1) {
                fn_prevPage(rootStore);
              }
              if (rootStore.searchStore.getSearchNoDataVal === "SEARCH") {
                rootStore.searchStore.setOrderSearchNoDataView(true);
              }
              rootStore.searchStore.setSearchNoDataVal("NO_DATA");
            }
          }
        }
      }
    })
    .catch((err) => {});
}

// 주문이 존재하는 페이지 조회(상세보기 바로가기 때문에 필요함)
export async function api_order_list_get_page(rootStore, mobileOrderNo, isCid) {
  const searchStore = rootStore.searchStore;
  const settingStore = rootStore.settingStore;
  let data = JSON.stringify({
    ...searchStore.getShopCdSaleDate,
    orderType: searchStore.getCurrOrderType,
    stepType: searchStore.getCurrStepType,
    viewType: settingStore.getOrderViewType,
    viewOrder: settingStore.getOrderViewOrder,
    searchKey: searchStore.getSearchKey.key,
    searchVal: searchStore.getSearchVal,
    mobileOrderNo: mobileOrderNo,
    orderEndYn: settingStore.getManagerSetting.orderEnd,
  });
  const api = Fn_activeAxios(rootStore);
  let res = await api
    .post("/gate/okgo/orders/orderPage", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + rootStore.searchStore.getToken,
      },
    })
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            if (data.hitPage != 0) {
              if (!isCid) {
                rootStore.orderStore.setPagingInfo("page_no", data.hitPage);
              }
              rootStore.orderStore.setPagingInfo("max_page", data.maxPage);
            }
          }
        }
      }
    })
    .catch((err) => {});
  return res;
}

// 주문 목록 조회
export async function api_order_search_list(rootStore, type) {
  const searchStore = rootStore.searchStore;
  const orderStore = rootStore.orderStore;
  const settingStore = rootStore.settingStore;

  if (
    rootStore.settingStore.getUserInfo.userId == "" ||
    rootStore.settingStore.getUserInfo.userNm == ""
  ) {
    rootStore.settingStore.setUserInfo(
      "userId",
      localStorage.getItem("userId")
    );
    rootStore.settingStore.setUserInfo(
      "userNm",
      localStorage.getItem("userNm")
    );
  }

  let data = JSON.stringify({
    ...searchStore.getShopCdSaleDate,
    orderType: searchStore.getCurrOrderType,
    stepType: searchStore.getCurrStepType,
    viewType: settingStore.getOrderViewType,
    viewOrder: settingStore.getOrderViewOrder,
    pageNo: orderStore.getPagingInfo.page_no,
    searchKey: searchStore.getSearchKey.key,
    searchVal: searchStore.getSearchVal,
    userId: settingStore.getUserInfo.userId,
    userNm: settingStore.getUserInfo.userNm,
    orderEndYn: settingStore.getManagerSetting.orderEnd,
  });
  const api = Fn_activeAxios(rootStore);
  let res = await api
    .post("/gate/okgo/search_main_list", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + rootStore.searchStore.getToken,
      },
    })
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            orderStore.addOrderListAll(
              rootStore.rabbitMqStore.getRabbitAllNew,
              data.list
            );
            orderStore.setPagingInfo("max_page", Number(data.maxPage));
            orderStore.setPagingInfo("end_max_page", Number(data.maxPage));
            rootStore.endOrderStore.setEndOrderCompleteList(data.list);

            if (data.list.length > 0) {
              // 하단 알림 문구 layer 제거
              rootStore.searchStore.setOrderSearchNoDataView(false);
            } else {
              if (rootStore.searchStore.getSearchNoDataVal === "SEARCH") {
                rootStore.searchStore.setOrderSearchNoDataView(true);
              }
              rootStore.searchStore.setSearchNoDataVal("NO_DATA");
            }
            return true;
          }
        }
      }
    })
    .catch((err) => {});
  return res;
}

// 주문 목록 갱신
export function reload_order_list(rootStore) {
  api_order_list(rootStore);
}

export function reload_order_list_all(rootStore, type) {
  if (rootStore.settingStore.getManagerSetting?.orderEnd == "Y") {
    if (type == undefined) {
      type = "all";
    }
    //rootStore.searchStore.setCurrStepType(type);
  } else {
    rootStore.searchStore.setCurrStepType("all");
  }
  api_order_type(rootStore);
  api_order_list(rootStore); // 주문 목록 조회
}

//pos push후 완료 주문건 갱신
export function reload_order_end_list_all(rootStore) {
  rootStore.settingStore.setManagerSetting("orderEnd", "Y");
  rootStore.searchStore.setCurrStepType("all");
  //api_order_list_paging(rootStore)
  api_order_type(rootStore);
  api_order_list(rootStore, "posPush"); // 주문 목록 조회
}

// 매출수기등록
export async function api_send_order_list(rootStore) {
  const searchStore = rootStore.searchStore;
  const orderStore = rootStore.orderStore;
  const viewStore = rootStore.viewStore;
  const layerStore = rootStore.layerStore;

  let data = JSON.stringify({
    posNo: searchStore.getSession.connPosNo,
    saleDate: searchStore.getSaleDate,
    shopCd: searchStore.getShopCd,
    saleRegistrationInfo: orderStore.getOrderRegistAdd,
  });

  const api = Fn_activeAxios(rootStore);
  let res = await api
    .post("/gate/okgo/orders/forcedSales", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + rootStore.searchStore.getToken,
      },
    })
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            fn_bridge_close(rootStore);
          }
        } else {
          rootStore.layerStore.setLayerRequiredAlert("view", true);
          rootStore.layerStore.setLayerRequiredAlert(
            "txt",
            "처리 실패하였습니다.\n재시도 해주세요"
          );
        }
      } else {
        rootStore.layerStore.setLayerRequiredAlert("view", true);
        rootStore.layerStore.setLayerRequiredAlert(
          "txt",
          "처리 실패하였습니다.\n다시시도 해주세요"
        );
      }
    })
    .catch((err) => {
      rootStore.layerStore.setLayerRequiredAlert("view", true);
      rootStore.layerStore.setLayerRequiredAlert(
        "txt",
        "처리 실패하였습니다.\n문의해주세요"
      );
    });
  return res;
}

//기존 주문 팝업 재호출
export async function api_notify_reload(rootStore) {
  let data = JSON.stringify({
    //posNo: rootStore.viewStore.getOrderDetail.posNo,
    posNo: rootStore.searchStore.getSession.connPosNo,
    shopCd: rootStore.searchStore.getShopCd,
  });
  fn_log_error("", "api_notify_reload", data);
  const api = Fn_activeAxios(rootStore);
  let result = false;
  let res = await api
    .post("/gate/okgo/popup/orders", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + rootStore.searchStore.getToken,
      },
    })
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          if (res.data.data.isSendQueue) {
            result = true; //신규 팝업 큐 보냄
          }
        }
      }
    })
    .catch((err) => {});

  return result;
}
